import drawRoutes from '../../router/utils/drawRoutes';

import { RouteType } from '../../router/utils/types';

type Props = {
  routes: RouteType[];
};

const RequiredTemplate = ({ routes }: Props) => {
  return drawRoutes(routes);
};

export default RequiredTemplate;
